import moment from 'moment-timezone';
import { defaultTo } from 'lodash';
import { INTERRUPT_CHECK_DAYS } from './constants';

// Helper to execute date and time related operations for content from graphql-server

const MOMENT_TZ_TORONTO = 'America/Toronto';
const MOMENT_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
const MOMENT_DATE_MIN = '1970-01-01T00:00:00';
const MOMENT_DATE_MAX = '2099-12-31T23:59:59';

export const filterOutNull = (arr) => {
  if (arr && arr.constructor === Array) {
    return arr.filter((item) => item !== null && item !== undefined);
  }
  return [];
};

export const isNotExpired = (item, startDateField, endDateField) => {
  const startDate = item[startDateField];
  const endDate = item[endDateField];

  if (!startDate || !endDate) {
    return false;
  }

  const currentMoment = moment().tz(MOMENT_TZ_TORONTO);
  const startMoment = moment.tz(
    defaultTo(startDate, MOMENT_DATE_MIN),
    MOMENT_DATETIME_FORMAT,
    MOMENT_TZ_TORONTO,
  );
  const endMoment = moment.tz(
    defaultTo(endDate, MOMENT_DATE_MAX),
    MOMENT_DATETIME_FORMAT,
    MOMENT_TZ_TORONTO,
  );

  return (
    currentMoment.isSameOrAfter(startMoment)
    && currentMoment.isSameOrBefore(endMoment)
  );
};

export const filterOutExpired = (arr, startDate, endDate) => {
  if (arr && arr.constructor === Array) {
    return arr.filter((item) => isNotExpired(item, startDate, endDate));
  }
  return [];
};

export const getExpiryTimeout = (endDate) => {
  const currentMoment = moment().tz(MOMENT_TZ_TORONTO);
  const expiryMoment = moment.tz(
    endDate || MOMENT_DATE_MAX,
    MOMENT_DATETIME_FORMAT,
    MOMENT_TZ_TORONTO,
  );
  return Math.min(expiryMoment.diff(currentMoment), 2147483646);
};

export const showInterruptMessage = (props) => {
  // Determine if journey should be interrupted
  const {
    shopData: { interstitialInterrupt, id: shopId, lastUpdated },
    userData: { interruptShops = [] },
  } = props;

  if (!interstitialInterrupt) {
    return false;
  }

  const today = moment();

  // Determine whether the user has opted out of seeing the important information
  const interruptShop = interruptShops.find((shopObj) => shopObj.id === shopId);

  // Determine the number of days since the shop was updated
  const daysSinceShopUpdate = moment
    .duration(today.diff(moment(lastUpdated)))
    .as('days');

  // console.log({ interruptShop, daysSinceShopUpdate });

  if (!interruptShop || daysSinceShopUpdate < INTERRUPT_CHECK_DAYS) {
    return true;
  }

  // Determine the number of days since the user was last interrupted for shop
  const daysSinceLastInterrupt = moment
    .duration(today.diff(moment(interruptShop.dateAdded)))
    .as('days');

  // console.log({ daysSinceLastInterrupt, INTERRUPT_CHECK_DAYS });

  if (
    daysSinceLastInterrupt >= INTERRUPT_CHECK_DAYS
    || daysSinceShopUpdate < daysSinceLastInterrupt
  ) {
    return true;
  }

  return false;
};
